import script from "./FranchiseDay.vue?vue&type=script&setup=true&lang=js"
export * from "./FranchiseDay.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import FranchiseDayHeader from "@/components/franchise/FranchiseDayHeader.vue";
import SecondaryNav from "@/components/SecondaryNav.vue";
script.components = Object.assign({}, { FranchiseDayHeader, SecondaryNav }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { FranchiseDayHeader, SecondaryNav }, script.__o.components);}